import matchQualityInfo from './MatchQualityInfo.vue';
import matchScoreWeightInfo from './MatchScoreWeightInfo.vue';
import relevantCategoriesInfo from './RelevantCategoriesInfo.vue';
import sortingAlgorithmInfo from './SortingAlgorithmInfo.vue';
import spellingCorrectionInfo from './SpellingCorrectionInfo.vue';

export default {
  matchScoreWeightInfo,
  sortingAlgorithmInfo,
  matchQualityInfo,
  spellingCorrectionInfo,
  relevantCategoriesInfo,
};
